import React from 'react'
import FormField from '@/components/common/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { useFormContext } from 'react-hook-form'
import type { OnboardTabProps } from './onboard.types'

const OnboardDocuments: React.FC<OnboardTabProps> = ({ isLoading, handleNextStep, uploadFile }) => {
    const methods = useFormContext()
    const { formState: { errors }, setValue, watch } = methods

    const handleFileChange = (name: any) => async (e: any) => {
        const file = (e.target as HTMLInputElement).files?.[0]
        if (file && uploadFile) {
            const path = await uploadFile(file)
            if (path) {
                setValue(name, path, { shouldValidate: true })
            }
        }
    }

    return (
        <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <FormField
                        type="file"
                        label="Aadhar Card Front"
                        placeholder="Upload aadhar front"
                        onChange={handleFileChange('aadharFront')}
                        error={errors.aadharFront?.message as string}
                    />
                    {watch('aadharFront') && <p className="text-xs text-green-600 mt-1">Uploaded successfully</p>}
                </div>
                <div>
                    <FormField
                        type="file"
                        label="Aadhar Card Back"
                        placeholder="Upload aadhar back"
                        onChange={handleFileChange('aadharBack')}
                        error={errors.aadharBack?.message as string}
                    />
                    {watch('aadharBack') && <p className="text-xs text-green-600 mt-1">Uploaded successfully</p>}
                </div>
                <div>
                    <FormField
                        type="file"
                        label="PAN Card"
                        placeholder="Upload pan card front"
                        onChange={handleFileChange('panFront')}
                        error={errors.panFront?.message as string}
                    />
                    {watch('panFront') && <p className="text-xs text-green-600 mt-1">Uploaded successfully</p>}
                </div>
                <div>
                    <FormField
                        type="file"
                        label="Degree Document"
                        placeholder="Upload certificate"
                        onChange={handleFileChange('degreeDoc')}
                        error={errors.degreeDoc?.message as string}
                    />
                    {watch('degreeDoc') && <p className="text-xs text-green-600 mt-1">Uploaded successfully</p>}
                </div>
            </div>
            <div className="flex justify-end mt-6">
                <Button
                    type="button"
                    onClick={() => handleNextStep('tab9', ['aadharFront', 'aadharBack', 'panFront', 'degreeDoc'])}
                    disabled={isLoading}
                >
                    {isLoading ? <Spinner /> : 'Save and Continue'}
                </Button>
            </div>
        </div>
    )
}

export default OnboardDocuments
